import { cn } from '@/lib/utils'
import {
  LOCKUP_WIDTH,
  LOGO_MARK,
  WORDMARK,
  WORDMARK_TRANSFORM,
} from './logo-paths'

// Otti One logo. The mark takes its colour from `markClassName` (default brand teal),
// the wordmark from `currentColor`, so `text-white` on a dark band is enough.
// Standalone files for print and social: public/brand/.
// Pass title="" when a surrounding link already names the logo; the SVG is then hidden from screen readers.

const a11y = title =>
  title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true }

export function LogoMark({ className, title = 'Otti One' }) {
  return (
    <svg
      viewBox="0 0 32 32"
      {...a11y(title)}
      className={cn('h-8 w-8 fill-primary', className)}
    >
      <path d={LOGO_MARK} fillRule="evenodd" />
    </svg>
  )
}

export function Logo({ className, markClassName, title = 'Otti One' }) {
  return (
    <svg
      viewBox={`0 0 ${LOCKUP_WIDTH} 32`}
      {...a11y(title)}
      className={cn('h-8 w-auto', className)}
    >
      <path
        d={LOGO_MARK}
        fillRule="evenodd"
        className={cn('fill-primary', markClassName)}
      />
      <path d={WORDMARK} transform={WORDMARK_TRANSFORM} fill="currentColor" />
    </svg>
  )
}
